
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ioDaq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetchGroups", () => $dc4a6737addb2831$export$ec3da3f4c8611742);
$parcel$export(module.exports, "default", () => $dc4a6737addb2831$export$2e2bcd8739ae039);

var $fcWBJ = parcelRequire("fcWBJ");

var $2OdyW = parcelRequire("2OdyW");

var $9zYls = parcelRequire("9zYls");
const $dc4a6737addb2831$export$ec3da3f4c8611742 = async (projectKey, cloudId)=>{
    if (false) return (0, $2OdyW.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`, {
        headers: {
            'x-ssr-service-name': 'jsm-kukama'
        }
    });
    return (0, $2OdyW.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc4a6737addb2831$export$2e2bcd8739ae039 = async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { cloudId: cloudId } = tenantContext;
    const projectKey = (0, $9zYls.getProjectKeyId)(match, query).projectKey;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const data = await $dc4a6737addb2831$export$ec3da3f4c8611742(projectKey, cloudId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category'); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});


//# sourceMappingURL=async-resource-servicedesk-queues-priority-group-data-loader.01648bd2.js.map
